document.querySelectorAll("[data-social-share]").forEach((shareContainer) => {
	const triggerButton = shareContainer.querySelector("[data-social-share-trigger]");
	const itemContainer = shareContainer.querySelector("[data-social-share-items]");
	const items = Array.from(itemContainer.children);

	itemContainer.style.setProperty("--animation-total-items", itemContainer.children.length);
	itemContainer.style.setProperty("--animation-delay-in", "calc(var(--delay) * " + 0 + ")");
	itemContainer.style.setProperty("--animation-delay-out", "calc(var(--delay) * " + itemContainer.children.length + " )");
	itemContainer.style.setProperty("--max-height", "45px");
	itemContainer.setAttribute("hidden", "");
	itemContainer.querySelectorAll("*").forEach((link) => {
		if (link.matches("button, a")) {
			link.setAttribute("tabindex", "-1");
		}
	});

	// Handle the timing of the items
	items.forEach((item, index) => {
		let timingIn = index + 1;
		let timingOut = itemContainer.children.length - index;

		item.style.setProperty("z-index", "-" + index);
		item.style.setProperty("--animation-order", index);
		item.style.setProperty("--animation-delay-in", "calc(var(--delay) / 1.5 * " + timingIn + " )");
		item.style.setProperty("--animation-delay-out", "calc(var(--delay) / 1.5 * " + timingOut + " )");

		/**
		 * We need to prevent propagation on these items
		 * so that we can listen to the parent for transitionend
		 * to handle hiding the container element
		 */
		item.addEventListener("transitionend", (e) => {
			e.stopPropagation();
		});
	});

	// Handle the toggling of elements
	triggerButton.addEventListener("click", () => {
		triggerButton.classList.toggle("active");
		itemContainer.classList.toggle("active");

		if (triggerButton.classList.contains("active")) {
			itemContainer.removeAttribute("hidden");
			itemContainer.querySelectorAll("*").forEach((link) => {
				if (link.matches("button, a")) {
					link.setAttribute("tabindex", "0");
				}
			});
		} else {
			itemContainer.style.maxHeight = null;
			itemContainer.querySelectorAll("*").forEach((link) => {
				if (link.matches("button, a")) {
					link.setAttribute("tabindex", "-1");
				}
			});
			itemContainer.addEventListener(
				"transitionend",
				() => {
					itemContainer.setAttribute("hidden", "");
				},
				{ once: true }
			);
		}
	});
});
